import React from 'react';
import { Loader2 } from 'lucide-react';

interface ImportProgressProps {
  stage: 'uploading' | 'processing';
  progress: number;
  message?: string;
}

const ImportProgress: React.FC<ImportProgressProps> = ({
  stage,
  progress,
  message,
}) => {
  const getStageMessage = () => {
    if (message) return message;

    switch (stage) {
      case 'uploading':
        return 'Uploading file...';
      case 'processing':
        return 'Processing loans...';
      default:
        return 'Working...';
    }
  };

  return (
    <div className="py-12" data-test-id="import-progress">
      <div className="flex flex-col items-center">
        <Loader2
          className="w-12 h-12 text-blue-600 animate-spin mb-4"
          data-test-id="import-progress-spinner"
        />

        <h3
          className="text-lg font-medium text-gray-900 mb-2"
          data-test-id="import-progress-title"
        >
          {getStageMessage()}
        </h3>

        <div
          className="w-full max-w-xs mb-4"
          data-test-id="import-progress-bar-container"
        >
          <div className="bg-gray-200 rounded-full h-2 overflow-hidden">
            <div
              className="bg-blue-600 h-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
              data-test-id="import-progress-bar"
            />
          </div>
        </div>

        <p
          className="text-sm text-gray-600"
          data-test-id="import-progress-percentage"
        >
          {progress}% complete
        </p>

        {stage === 'processing' && (
          <p
            className="text-xs text-gray-500 mt-4 text-center max-w-sm"
            data-test-id="import-progress-note"
          >
            This may take a few moments depending on the size of your file and
            the number of loans being imported.
          </p>
        )}
      </div>
    </div>
  );
};

export default ImportProgress;
